class ExtractsService {
  constructor(httpDim, config) {
    this.httpDim = httpDim;
    this.config = config;
    this.url = `${this.config.apiRoot}/extracts`;
  }

  createExtract(customerId,type,batchId) {
    let body = {
      customerId : customerId,
      type: type
    };

    if (batchId) {
      body.batchId = batchId;
      body.sourceName = `/batch/${batchId}`;
    }

    return this.httpDim.post(this.url, body);
  }
}

ExtractsService.$inject = ['httpDim', 'config'];

export default ExtractsService;



// WEBPACK FOOTER //
// ./app/common/extracts/extracts.service.js